import React from 'react';
import { 
    Box, 
    Typography, 
    IconButton,
    Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export default function POPage() {
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                mb: 2
            }}>
                <IconButton onClick={() => navigate('/main')} edge="start">
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" fontWeight="600">
                    Purchase Orders (PO)
                </Typography>
            </Box>

            <Alert severity="warning">
                Test page - This module is currently under development
            </Alert>
        </Box>
    );
}